import React, { Fragment } from "react";
import IntlMessages from "Util/IntlMessages";
import {
  Row,
  Card,
  CardBody,
  NavItem,
  Button,
  Badge,
  Form,
  Label,
  Input
} from "reactstrap";

import { Colxx, Separator } from "Components/CustomBootstrap";
import { BreadcrumbItems } from "Components/BreadcrumbContainer";
import { NavLink } from "react-router-dom";
import EmailsMenu from "Components/EmailsMenu";
import Gallery from "react-fine-uploader";
import "react-fine-uploader/gallery/gallery.css";
import FineUploaderTraditional from "fine-uploader-wrappers";
import ClassicText from "Components/RichEditor/classicEditor";

import PerfectScrollbar from "react-perfect-scrollbar";
const uploader = new FineUploaderTraditional({
  options: {
    chunking: {
      enabled: false
    },
    deleteFile: {
      enabled: true,
      endpoint: "/uploads"
    },
    request: {
      endpoint: "/uploads"
    }
  }
});

const COMPOSE_SCROLL = { suppressScrollX: true, wheelPropagation: false };

function ComposeMails() {
  return (
    <Fragment>
        <Row>
          <Colxx xxs="12">
            <div className="mb-2">
              <h1>
                <IntlMessages id="menu.emails" />
              </h1>
              <BreadcrumbItems />
            </div>

            <Separator className="mb-5" />

            <Row>
              <Colxx xl="4" xxs="1" lg="1" md="1">
                <EmailsMenu>
                  <PerfectScrollbar option={COMPOSE_SCROLL}>
                    <div className="p-4">
                      <Button
                        href="/app/mails/compose-mails"
                        color="primary"
                        size="lg"
                        className="mt-3 mb-5"
                      >
                        <IntlMessages id="emails.compose-email" />
                      </Button>
                      <ul className="list-unstyled mb-5">
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-envelope" />
                            <IntlMessages id="emails.inbox" />
                            <span className="float-right">
                              <Badge color="primary">23</Badge>
                            </span>
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-file" />
                            <IntlMessages id="emails.draft" />
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="fa fa-exchange-alt" />
                            <IntlMessages id="emails.sent" />
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="fab fa-gripfire" />
                            <IntlMessages id="emails.spam" />
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-trash-alt" />
                            <IntlMessages id="emails.trash" />
                            <span className="float-right">
                              <Badge color="danger">4</Badge>
                            </span>
                          </NavLink>
                        </NavItem>
                        <Separator className="my-5" />
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-address-book" />
                            <IntlMessages id="emails.address-book" />
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-folder" />
                            <IntlMessages id="emails.user-folders" />
                          </NavLink>
                        </NavItem>
                        <Separator className="mt-5 mb-3" />
                        <strong>
                          Friends{" "}
                          <span className="float-right">
                            <Badge>New</Badge>
                          </span>
                        </strong>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-circle font-color-1" />
                            Joey K. Greyson
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-circle font-color-2" />
                            Andrea Branden
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-circle font-color-3" />
                            Lucy Moon
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-circle font-color-4" />
                            Johny Juan
                          </NavLink>
                        </NavItem>
                        <NavItem className="my-3">
                          <NavLink to="#">
                            <i className="far fa-circle font-color-5" />
                            Susan Sun
                          </NavLink>
                        </NavItem>
                        <Separator className="mt-5 mb-3" />
                        <strong>Labels </strong>
                        <p className="mt-3">
                          <NavLink to="#">
                            <Badge color="light" className="text-dark">
                              <i className="fa fa-tags" /> Family
                            </Badge>{" "}
                          </NavLink>
                          <NavLink to="#">
                            <Badge
                              color="light"
                              className="mx-1 my-1 text-dark"
                            >
                              <i className="fa fa-tags" /> Home
                            </Badge>{" "}
                          </NavLink>
                          <NavLink to="#">
                            <Badge
                              color="light"
                              className="mx-1 my-1 text-dark"
                            >
                              <i className="fa fa-tags" /> Work
                            </Badge>
                          </NavLink>
                          <NavLink to="#">
                            <Badge
                              color="light"
                              className="mx-1 my-1 text-dark"
                            >
                              <i className="fa fa-tags" /> Film
                            </Badge>
                          </NavLink>
                          <NavLink to="#">
                            <Badge
                              color="light"
                              className="mx-1 my-1 text-dark"
                            >
                              <i className="fa fa-tags" /> Music
                            </Badge>
                          </NavLink>
                          <NavLink to="#">
                            <Badge
                              color="light"
                              className="mx-1 my-1 text-dark"
                            >
                              <i className="fa fa-tags" /> Photography
                            </Badge>
                          </NavLink>
                        </p>
                      </ul>
                    </div>
                  </PerfectScrollbar>
                </EmailsMenu>
              </Colxx>
              <Colxx className="ms-auto" xxs="11" lg="11" xl="8" md="11">
                <div>
                  <Card>
                    <CardBody>
                      <div className="mt-3">
                        <Form>
                          <Label for="sendEmail" className="mr-sm-2">
                            To :
                          </Label>
                          <Input type="email" name="email" id="sendEmail" />

                          <Label for="emailSubject" className="mr-sm-2 mt-3">
                            Subject :
                          </Label>
                          <Input type="email" name="email" id="emailSubject" />
                        </Form>
                      </div>
                      <div className="mt-3">
                        <Gallery
                          animationsDisabled={true}
                          uploader={uploader}
                          {...{
                            "deleteButton-children": <span>Delete</span>,
                            "fileInput-children": <span />
                          }}
                        >
                          <span className="react-fine-uploader-gallery-dropzone-content">
                            <span className="fa fa-link font-color-1 fa-3x " />
                          </span>
                        </Gallery>
                      </div>
                      <div className="mt-5 mb-3">
                        <ClassicText />
                      </div>
                      <Button color="primary" size="lg" className="mt-3 mb-5">
                        <IntlMessages id="emails.send" />
                      </Button>
                    </CardBody>
                  </Card>
                </div>
              </Colxx>
            </Row>
          </Colxx>
        </Row>
      </Fragment>
  );
}

export default ComposeMails;
